import React, { Component } from 'react'
import styled, { css } from 'styled-components'
import { Button } from 'semantic-ui-react'
import { AppContext } from 'src/context/AppContext'

const weeks = {
  monday: '月',
  tuesday: '火',
  wednesday: '水',
  thursday: '木',
  friday: '金',
  saturday: '土',
  sunday: '日'
}

class WeekSelector extends Component {
  constructor (props) {
    super(props)
    this.state = Object.keys(weeks).reduce((obj, key) => {
      obj[key] = false
      return obj
    }, {})
  }

  render () {
    return (
      <AppContext.Consumer>
        {({ state, actions }) => (
          <div>
            {state.interval === 'week' && (
              <div>
                <CheckButton
                  basic
                  color={'blue'}
                  compact
                  onClick={actions.selectWeekDays}
                >
                  平日
                </CheckButton>
                <CheckButton
                  basic
                  color={'blue'}
                  compact
                  onClick={actions.selectHolidays}
                >
                  休日
                </CheckButton>
              </div>
            )}
            {Object.keys(weeks).map(key => (
              <CheckboxWrapper key={key}>
                <Checkbox
                  checked={state.weeks[key]}
                  onClick={actions.handleClickWeek(key)}
                >
                  {weeks[key]}
                </Checkbox>
              </CheckboxWrapper>
            ))}
          </div>
        )}
      </AppContext.Consumer>
    )
  }
}

export default WeekSelector

const CheckboxWrapper = styled.div`
  display: inline-block;
  margin-right: 16px;

  @media (max-width: 830px) {
    margin-right: 10px;
  }
`

const Checkbox = styled.div`
  width: 42px;
  height: 42px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #9b9b9b;
  background-color: #f0f3f4;

  ${props =>
    props.checked &&
    css`
      color: #fff;
      background-color: #6ecadc;
    `}

  @media (max-width: 830px) {
    margin-bottom: 12px;
  }
`

const CheckButton = styled(Button)`
  && {
    margin-bottom: 16px;
    margin-right: 8px;
  }
`
